















































































































































import { Component, Vue } from 'vue-property-decorator';
import search360Page from '@/api/search360Page';
import customForm from './formCustom.vue';
import { formType } from './types';

@Component({
  components: {
    customForm,
  },
})
export default class Search360PagePC extends Vue {
  commonProblemList: Array<any> = [
    {
      tag: 1,
      question: '美团充电宝怎么合作？',
      answer: '按照表单填写要求，提交相关信息，美团充电宝招商经理将会在3个工作日联系您。',
    },
    {
      tag: 2,
      question: '具体的合作模式是怎样的？',
      answer: '您只需采购美团充电宝设备，并且投放到门店，就能享受用户租借流水分成。',
    },
    {
      tag: 3,
      question: '购买设备后，怎么铺设？',
      answer: '如果您有门店资源，可以自己将设备铺设到门店；如果您缺少门店资源，美团会为您提供商户资源扶持。',
    },
    {
      tag: 4,
      question: '有售后吗？合作后出现问题怎么解决？',
      answer: '美团充电宝有专业售后团队，为合伙人提供服务；充电宝合作问题，可直接咨询您的专属渠道经理；充电宝使用问题，可直接拨打官方客服电话：400-000-5658。',
    },
    {
      tag: 5,
      question: '合作收益怎么分成？美团收取费用吗？',
      answer: '合作成功后，美团只收取小比例的平台服务费，不收取除此以外的其它任何费用。',
    },
  ]

  selectedTag: any = this.commonProblemList[0]

  showModal: boolean = false

  formCustom1: formType = {
    mobile: '',
    captcha: '',
    // clueType: null,
    budgetScope: '',
  }

  formCustom2: formType = {
    mobile: '',
    captcha: '',
    // clueType: null,
    budgetScope: '',
  }

  submitting: Boolean = false

  type: any = ''

  uuid: string = ''

  get fromOpportunity() {
    const { fromOpportunity } = this.$route.query;
    return fromOpportunity ? Number(fromOpportunity) : null;
  }

  get lch() {
    const { lch } = this.$route.query;
    return lch;
  }

  created() {
    if (window.LXAnalytics) {
      window.LXAnalytics('get', 'uuid', (data: string) => {
        this.uuid = data;
      });
    }
  }

  changeSelect(index: number) {
    this.selectedTag = this.commonProblemList[index];
  }

  serialNumberColor(tag: number) {
    switch (tag) {
      case 1:
        return '#FF001C';
      case 2:
        return '#FF4B10';
      case 3:
        return '#FFA200';
      case 4:
        return '#FFD100';
      case 5:
        return '#999999';
      default:
        return '#999999';
    }
  }

  openModal() {
    this.showModal = true;
  }

  async onSubmit(noPopup: boolean) {
    const form = noPopup ? 'formCustom1' : 'formCustom2';
    try {
      await (this.$refs[form] as any).validate();
      if (this.submitting) return;
      this.submitting = true;
      await this.onSave(noPopup);
      this.submitting = false;
    } catch (error) {
      // console.log(error);
    }
  }

  async onSave(noPopup: boolean) {
    const form = noPopup ? 'formCustom1' : 'formCustom2';
    const params = {
      mobile: this[form].mobile,
      // clueType: this[form].clueType,
      type: this.fromOpportunity,
      lch: this.lch,
      uid: this.uuid,
      url: window.location.href,
      checkInfo: {
        mobileNo: this[form].mobile,
        uuid: this.uuid,
        captcha: this[form].captcha,
        action: 'merchantlandfloor',
      },
      clueInfo: {
        budgetScope: this[form].budgetScope,
      },
    };
    const { error, data }: ApiResponse.MDPData = await search360Page.save(params);
    if (!error && data) {
      if (!noPopup) this.showModal = false;
      this.$mtd.confirm({
        title: '成功提示',
        message: '提交成功，电销经理将在1-3个工作日内联系您。',
        width: '430px',
        type: 'success',
        okButtonText: '我知道了',
      });
    }
  }
}
